module.exports = __webpack_public_path__ + "static/img/global_mail@3x.9cad1f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_mail@3x.png
// module id = lmsq
// module chunks = 1